var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "api-layer" }, [
    _c("fieldset", [
      _c("legend", [_vm._v("System")]),
      _c(
        "div",
        { staticClass: "api-box", class: { inline: !_vm.serverInfo.desc } },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("server")]),
          _c("button", { on: { click: _vm.getServerInfo } }, [_vm._v("OK")]),
          !!_vm.serverInfo.desc
            ? _c("div", [
                _c("pre", [
                  _vm._v(
                    "          LastReq: " +
                      _vm._s(_vm.serverInfo.desc.lastReqDate) +
                      "\n          ServerId: " +
                      _vm._s(_vm.serverInfo.desc.serverId) +
                      "\n          CpuLoad: " +
                      _vm._s(_vm.serverInfo.desc.cpuLoad) +
                      " %\n          CpuProcs: " +
                      _vm._s(_vm.serverInfo.desc.arch) +
                      ", " +
                      _vm._s(_vm.serverInfo.desc.availableProcessors) +
                      " cores\n          Memory: total[" +
                      _vm._s(_vm.serverInfo.desc.totalPhysicalMemorySize) +
                      "MB], use[" +
                      _vm._s(_vm.serverInfo.desc.usePhysicalMemorySize) +
                      "MB], free[" +
                      _vm._s(_vm.serverInfo.desc.freePhysicalMemorySize) +
                      "MB]\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        { staticClass: "api-box", class: { inline: !_vm.systemInfo.desc } },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("system")]),
          _c("button", { on: { click: _vm.getSystemInfo } }, [_vm._v("OK")]),
          !!_vm.systemInfo.desc
            ? _c("div", [
                _c("pre", [
                  _vm._v(
                    "          LastReq: " +
                      _vm._s(_vm.systemInfo.desc.lastReqDate) +
                      "\n          ServerId: " +
                      _vm._s(_vm.systemInfo.desc.serverId) +
                      "\n          Memory: total[" +
                      _vm._s(_vm.systemInfo.desc.memory.total) +
                      "MB], use[" +
                      _vm._s(_vm.systemInfo.desc.memory.use) +
                      "MB], free[" +
                      _vm._s(_vm.systemInfo.desc.memory.free) +
                      "MB], max[" +
                      _vm._s(_vm.systemInfo.desc.memory.max) +
                      "MB]\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("div"),
      _c(
        "div",
        { staticClass: "api-box", class: { inline: !_vm.configInfo.data } },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("config")]),
          _c("button", { on: { click: _vm.getConfigAll } }, [_vm._v("OK")]),
          !!_vm.configInfo.data
            ? _c("div", [_c("pre", [_vm._v(_vm._s(_vm.configInfo.data))])])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }